import { render, staticRenderFns } from "./EachCountryGreetings.vue?vue&type=template&id=2966eaa3&scoped=true&"
import script from "./EachCountryGreetings.vue?vue&type=script&lang=js&"
export * from "./EachCountryGreetings.vue?vue&type=script&lang=js&"
import style0 from "./EachCountryGreetings.vue?vue&type=style&index=0&id=2966eaa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2966eaa3",
  null
  
)

export default component.exports